import {BASE_URL, DEVICE_TYPE, USER_TYPE} from '../../config'
import {REQUEST_STATE, RESET_STATUS_STATE, SET_SUCCESS_STATE, SET_ERROR_STATE, SET_TOKEN_REGISTER, SET_FINISH_REGISTER } from '../../utils/constants/actionTypes'
import {SRegist, SVerificationPhone, SResendVerification, SRegistComplete} from '../../config/api'

export const RegisterNoPonsel = data => async (dispatch) => {

    dispatch({type : RESET_STATUS_STATE});
    dispatch({type : REQUEST_STATE});

    try {
        const res = await fetch(`${BASE_URL}${SRegist}`, {
                        method : 'POST',
                        credentials: 'include',
                        headers : {
                            'Content-Type' : "application/json",
                            'X-User-Type' : USER_TYPE,
                            'X-Device-Type' : DEVICE_TYPE
                        },
                        body: JSON.stringify({ 
                            registration : {
                                phoneNumber : data,
                                borrowerType : 'COR'
                            } 
                        })
                    });

        const hasil = await res.json();
        
        console.log('masuk Reg Phone API')
        if(res.status === 200){
            dispatch({type : SET_SUCCESS_STATE, payload : hasil.status.message});
            dispatch({type : SET_TOKEN_REGISTER, payload : hasil.result.credential.token});
            console.log('masuk Reg Phone Success')
            return true;
        }else{
            dispatch({type : SET_ERROR_STATE, payload : hasil.status.message});
            console.log('masuk Reg Phone ERROR 1', hasil)
            return false;
        }
    } catch (err) {
		dispatch({ type: SET_ERROR_STATE, payload : err.message });
        console.log('masuk Reg Phone ERROR 2')
        return false;
    }
}

export const VerifyNoPonsel = data => async (dispatch) => {
    dispatch({type : RESET_STATUS_STATE});
    dispatch({type : REQUEST_STATE});

    try {
        const res = await fetch(`${BASE_URL}${SVerificationPhone}`, {
                        method : 'POST',
                        credentials: 'include',
                        headers : {
                            'Content-Type' : "application/json",
                            'X-Token' : data.token,
                        },
                        body: JSON.stringify({ 
                            registration : {
                                securityCode : data.securityCode,
                            } 
                        })
                    });

        const hasil = await res.json();
        
        if(res.status === 200){
            dispatch({type : SET_SUCCESS_STATE, payload : hasil.status.message});
            return true;
        }else{
            dispatch({type : SET_ERROR_STATE, payload : hasil.status.message});
            return false;
        }
    } catch (err) {
		dispatch({ type: SET_ERROR_STATE, payload : err.message });
        return false;
    }
}

export const ResendOtp = token => async (dispatch) => {
    dispatch({type : RESET_STATUS_STATE});
    dispatch({type : REQUEST_STATE});

    try {
        const res = await fetch(`${BASE_URL}${SResendVerification}`, {
                        method : 'POST',
                        credentials: 'include',
                        headers : {
                            'Content-Type' : "application/json",
                            'X-Token' : token
                        }
                    });

        const hasil = await res.json();
        
        if(res.status === 200){
            dispatch({type : SET_SUCCESS_STATE, payload : hasil.status.message});
            return true;
        }else{
            dispatch({type : SET_ERROR_STATE, payload : hasil.status.message});
            return false;
        }
    } catch (err) {
		dispatch({ type: SET_ERROR_STATE, payload : err.message });
        return false;
    }
}

export const RegisterEmail = ({data, token}) => async (dispatch) => {
    dispatch({type : RESET_STATUS_STATE});
    dispatch({type : REQUEST_STATE});

    try {
        const res = await fetch(`${BASE_URL}${SRegistComplete}`, {
                        method : 'POST',
                        credentials: 'include',
                        headers : {
                            'Content-Type' : "application/json",
                            'X-Token' : token,
                        },
                        body: JSON.stringify(data)
                    });

        const hasil = await res.json();
        
        console.log('masuk Registrasi Complate API')
        if(res.status === 201){
            dispatch({type : SET_SUCCESS_STATE, payload : hasil.status.message});
            dispatch({type : SET_FINISH_REGISTER});
            console.log('masuk Registrasi Complate SUCCESS')
            return true;
        }else{
            dispatch({type : SET_ERROR_STATE, payload : hasil.status.message});
            console.log('masuk Registrasi Complate Error 1')
            return false;
        }
    } catch (err) {
		dispatch({ type: SET_ERROR_STATE, payload : err.message });
        console.log('masuk Registrasi Complate Error 2')
        return false;
    }
}